"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toENSName = exports.isENSNameFormatIgnoreCase = void 0;
function isENSNameFormatIgnoreCase(str) {
    return str.indexOf('.') > 0;
}
exports.isENSNameFormatIgnoreCase = isENSNameFormatIgnoreCase;
function toENSName(str) {
    if (isENSNameFormatIgnoreCase(str)) {
        return str.toLowerCase();
    }
    throw new Error(`not a valid ENS name: "${str}"`);
}
exports.toENSName = toENSName;
//# sourceMappingURL=ENSName.js.map